module.exports = __webpack_public_path__ + "static/media/31_A.4b60e435.png";